import Vue from "vue";
import Component from "vue-class-component";
import { EVENTS } from "@/lib/const";
import emitter from "@/lib/helpers/emitter";

@Component({ name: "WithLoading" })
export default class WithLoadingStatus extends Vue {
  public loadingStatusShow(promiseArray: Array<Promise<any>>) {
    emitter.emit(EVENTS.LOADING.CHANGE, true);
    return Promise.all(promiseArray).finally(() => {
      emitter.emit(EVENTS.LOADING.CHANGE, false);
    });
  }
}
